import { render, staticRenderFns } from "./OrdersFBACreation.vue?vue&type=template&id=07dba59e&scoped=true"
import script from "./OrdersFBACreation.vue?vue&type=script&lang=js"
export * from "./OrdersFBACreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dba59e",
  null
  
)

export default component.exports